<h1>Files</h1>
<dx-data-grid biz-grid
              [dataSource]='files'
              (onRefresh)='refreshData()'
              [showIsLoading]="isLoading">
    <dxi-column dataField="FullName" caption="File Path" dataType="string" sortOrder="asc"></dxi-column>
    <dxi-column dataField="CreatedDate" [visible]="false" caption="Created" dataType="date" [width]="200" [format]="dateTimeService.getDevExpressDateTimeFunction"></dxi-column>
    <dxi-column dataField="ModifiedDate" caption="Last Modified" dataType="date" [width]="200" [format]="dateTimeService.getDevExpressDateTimeFunction"></dxi-column>
    <dxi-column dataField="Size" caption="Size" dataType="string" [width]="100"></dxi-column>
</dx-data-grid>